"use client";

import { useConvexAuth, useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import type { Id } from "@convex/_generated/dataModel";
import { canOpenAdminHref } from "@shared/auth/access";

const ADMIN_LISTINGS_HREF = "/admin/products";

export function adminListingHref(productId: Id<"products">): string {
  return `${ADMIN_LISTINGS_HREF}/${productId}`;
}

export function useCanEditListingsInAdmin(): boolean {
  const { isAuthenticated } = useConvexAuth();
  const current = useQuery(
    api.companies.queries.getCurrentUserWithCompany,
    isAuthenticated ? {} : "skip",
  );
  return canOpenAdminHref(current?.user, ADMIN_LISTINGS_HREF);
}
